import { Component, OnInit } from '@angular/core';
import { PatientContext } from 'app/mpi/lib/patient/services/patient-context';
import { ClinicalDocument } from 'app/integration/document/services/clinical-document';
import moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { Patient } from 'app/mpi/lib/patient/services/patient';
import { ClinicalDocumentService } from 'app/integration/document/services/clinical-document.service';
import { CodeSystemService } from 'app/mdm/terminology-lib/services/codesystem.service';
import { TranslateService } from '@ngx-translate/core';
import { AmbulanceCardSearchParams } from 'app/integration/document/ambulance-card/services/ambulance-card-search-params';
import { Organization } from 'app/mdm/lib/organization/services/organization';
import { AmbulanceCardService } from 'app/integration/document/ambulance-card/services/ambulance-card.service';
import { PatientService } from 'app/mpi/lib/patient/services/patient.service';
import { AuthContext } from '@heda/core-hospital-ui';
import { AmbulanceCard } from 'app/integration/document/ambulance-card/services/ambulance-card';
import { OrganizationService } from 'app/mdm/lib/organization/services/organization.service';

const STATUS_COMPLETED = 'completed';
const STATUS_ACTIVE = 'active';

@Component({
  selector: 'hw-ambulance-card-list',
  templateUrl: './ambulance-card-list.component.html',
})
export class AmbulanceCardListComponent implements OnInit {
  public loading = false;
  public params = new AmbulanceCardSearchParams();
  public documents: AmbulanceCard[] = [];
  public organization: Organization;
  public patient: Patient;
  public cardStatus: string;
  public statusOptions = [
    { label: 'integration.ambulance-card.filter.status.completed', value: STATUS_COMPLETED },
    { label: 'integration.ambulance-card.filter.status.active', value: STATUS_ACTIVE },
  ];

  constructor(
    public patientContext: PatientContext,
    private route: ActivatedRoute,
    private patientService: PatientService,
    private documentService: ClinicalDocumentService,
    private codeSystemService: CodeSystemService,
    private translateService: TranslateService,
    private ambulanceCardService: AmbulanceCardService,
    private authContext: AuthContext,
    private organizationService: OrganizationService
  ) {}

  public ngOnInit(): void {
    this.emptyFilter();
    const patientId = this.route.snapshot.paramMap.get('patientId');
    if (patientId) {
      this.patientService.getPatient(patientId).subscribe((res) => {
        this.patient = res;
        this.params.patient = res.id;
        this.search();
      });
    }
  }

  public search(): void {
    this.params.signed = this.cardStatus ? this.cardStatus === STATUS_COMPLETED : null;
    this.params.patient = this.patient ? this.patient.id : null;
    this.params.hospitalizationOrganizationCode = this.organization
      ? this.organization.identifiers.find((i) => i.system === 'cr').value
      : null;

    this.loading = true;
    this.ambulanceCardService.search(this.params).subscribe(
      (res) => {
        this.documents = res.data;
        this.loading = false;
      },
      (_) => {
        this.documents = [];
        this.loading = false;
      }
    );
  }

  public emptyFilter(): void {
    this.organizationService.load(this.authContext.userInfo.account.organization.id).subscribe(
      (res) => {
        this.organization = res;
      },
      (_) => (this.organization = null)
    );
    this.params = new AmbulanceCardSearchParams();
    this.params.from = moment().startOf('day').toDate();
    this.params.to = moment().endOf('day').toDate();
    this.patient = null;
    this.cardStatus = null;
  }

  public openDocument(document: ClinicalDocument): void {
    this.documentService.openDocument(document.type, document.identifier, document.patient.identifier);
  }
}
